<template src="./u-modal.html" />
<script src="./u-modal.ts" lang="ts"></script>
<style src="./u-modal.scss" lang="scss"></style>
